export const Unchecked = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66699 0.5H13.333C14.5296 0.5 15.5 1.47038 15.5 2.66699V13.333C15.5 14.5296 14.5296 15.5 13.333 15.5H2.66699C1.47038 15.5 0.5 14.5296 0.5 13.333V2.66699C0.5 1.47038 1.47038 0.5 2.66699 0.5Z"
      fill="white"
      stroke="#E6EAE8"
    />
  </svg>
);

export const Checked = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_479_9436)">
      <path
        d="M0 2.66667C0 1.19391 1.19391 0 2.66667 0H13.3333C14.8061 0 16 1.19391 16 2.66667V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667Z"
        fill="#3AD98F"
      />
      <path
        d="M12.2988 4.6416C12.5888 4.34589 13.0636 4.34188 13.3594 4.63184C13.6548 4.92184 13.66 5.39671 13.3701 5.69238L7.81348 11.3594C7.6725 11.5031 7.47962 11.5839 7.27832 11.584C7.07696 11.584 6.88322 11.5031 6.74219 11.3594L3.96484 8.52539C3.67491 8.22966 3.67897 7.75484 3.97461 7.46484C4.27031 7.17494 4.74515 7.18005 5.03516 7.47559L7.27734 9.7627L12.2988 4.6416Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_479_9436">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Loader = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    style={{ animation: 'var(--loader-animation)' }}
  >
    <g clipPath="url(#a)" data-figma-skip-parse="true">
      <foreignObject
        width="2000"
        height="2000"
        x="-1000"
        y="-1000"
        transform="matrix(.01 0 0 .01 12 12)"
      >
        <div
          style={{
            background:
              'conic-gradient(from 90deg,rgba(63,70,67,0) 0deg,#131514 359.964deg,rgba(63,70,67,0) 360deg)',
            height: '100%',
            width: '100%',
            opacity: 1,
          }}
        />
      </foreignObject>
    </g>
    <path
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M4 12a8 8 0 1 0 16 0 8 8 0 0 0-16 0"
      data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.074509806931018829,"g":0.082352943718433380,"b":0.078431375324726105,"a":1.0},"position":0.99989998340606689},{"color":{"r":0.24705882370471954,"g":0.27450981736183167,"b":0.26274511218070984,"a":0.0},"position":1.0}],"stopsVar":[],"transform":{"m00":19.999998092651367,"m01":0.0,"m02":2.0,"m10":0.0,"m11":19.999998092651367,"m12":2.0},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    />
    <defs>
      <clipPath id="a">
        <path d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M4 12a8 8 0 1 0 16 0 8 8 0 0 0-16 0" />
      </clipPath>
    </defs>
  </svg>
);
